<ul>
  <li *ngFor="let lang of langs">
    <button (click)="handleLangClick(lang)">
      {{ lang.name | uppercase }}
    </button>
  </li>
</ul>
